module.exports = __webpack_public_path__ + "img/cryptoknights.21df8d0f.png";